import React from 'react';
import CRModal from '.';
import Box from '@mui/material/Box';
import { SendFooterModal, ModalCTAButton, replaceValue } from './FooterModal';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import UiText from '../../shared/Typography/UiText';

interface ModalProps {
  modal: {
    open: boolean;
    onClose: () => void;
    onResendEmail?: () => void;
    onCloseModals?: () => void;
  };
  fieldProps: {
    modalCTAButtons: ModalCTAButton[];
    modalTitle?: { value: string };
    modalDescription?: { value: string };
  };
  emailResendCount?: number;
  email: string;
  hideResend?: boolean;
}

const SendModal: React.FC<ModalProps> = ({
  modal: { open, onClose, onResendEmail, onCloseModals },
  fieldProps,
  email,
  hideResend,
}) => {
  const { modalCTAButtons = [], modalTitle, modalDescription } = fieldProps;
  return (
    <>
      <CRModal open={open} handleClose={onClose} handleCancel={onClose} title={modalTitle?.value}>
        <Box sx={{ color: '#444444' }}>
          <UiText color="default">
            <RichText field={{ value: replaceValue(modalDescription?.value, { email: email }) }} />
          </UiText>
          <SendFooterModal
            modalCTAButtons={modalCTAButtons}
            onClose={onClose}
            onResend={onResendEmail}
            onCloseModals={onCloseModals}
            hideResend={hideResend}
          />
        </Box>
      </CRModal>
    </>
  );
};

export default SendModal;
